export const projects = [
  {
    title: "BlazeKitHub: Streamlined On-Premises Development",
    subtitle: "Blazor, Node.js, C#, JavaScript",
    description:
      "Your All-in-One Solution for Collaborative On-Premises Development",
    image: "./projects/project-1.gif",
    link: "#",
  },
  {
    title: "Hospital Management System",
    subtitle: "Windows App, C#, SQL, Azure",
    description:
      "Your Comprehensive Solution for Efficient Hospital Operations",
    image: "./projects/project-2.gif",
    link: "#",
  },
  {
    title: "Username Finder",
    subtitle: "Python",
    description:
      "In progress",
    image: "./projects/project-3.gif",
    link: "#",
  },
];

export const testimonials = [
  {
    quote:"",
    image: "testimonials/tmp1.png",
    name: "",
    company: "",
  },
  {
    quote:"",
    image: "testimonials/tmp2.png",
    name: "",
    company: "",
  },
  {
    quote: "",
    image: "testimonials/tmp3.png",
    name: "",
    company: "",
  },
];

export const skills = [
  "C# .Net",
  "JavaScript",
  "TypeScript",
  "Python",
  "Node.js",
  "SQL",
  "Oracle",
  "PostgreSQL",
];